import axios from "axios";
import * as Constant from "../global/const";

const httpClient = axios.create({
  baseURL: Constant.URL_BASE,
  timeout: null, // 2.5 horas
});

httpClient.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.headers[
      "Ocp-Apim-Subscription-Key"
    ] = `${process.env.REACT_APP_SUBCRIPTION_KEY}`;
    config.headers["Access-Control-Allow-Origin"] = "*";
    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

export default httpClient;
